import { configureStore } from "@reduxjs/toolkit";
import dialogSlice from "../components/dialog/dialogSlice";
import loginReducer from "../features/login/loginSlice";
import userSlice from "../features/user/userSlice";
import menuSlice from "../features/menu/menuSlice";
import rightsSlice from "../features/rights/rightsSlice";
import userTypeSlice from "../features/userType/userTypeSlice";
import muiDrawerSlice from "../components/muidrawer/muiDrawerSlice";
import dashboardSlice from "../features/dashboard/dashboardSlice";
import bannerSlice from "../features/banner/bannerSlice";
import cmsSlice from "../features/cms/cmsSlice";
import seotagSlice from "../features/seotag/seotagSlice";
import testimonialSlice from "../features/testimonial/testimonialSlice";
import blogSlice from "../features/blog/blogSlice";
import faqSlice from "../features/faq/faqSlice";
import usefullinksSlice from "../features/usefullinks/usefullinksSlice";
import paginationSlice from "../features/pagination/paginationSlice";
import settingSlice from "../features/setting/settingSlice";
import workflowSlice from "../features/workflow/workflowSlice";
import clientLogoSlice from "../features/clientlogo/clientLogoSlice";
import aboutSlice from "../features/about/aboutSlice";
import coreServiceSlice from "../features/coreservices/coreservicesSlice";
import serviceSlice from "../features/services/servicesSlice";
import weProvideSlice from "../features/weprovide/weProvideSlice";
import whyChooseSlice from "../features/whychoose/whyChooseSlice";
import branchesSlice from "../features/branches/branchSlice";
import technologySlice from "../features/technologies/technologySlice";
import workCultureSlice from "../features/workculture/workCultureSlice";
import bestplaceSlice from "../features/bestplace/bestPlaceSlice";
import workplaceSlice from "../features/workplace/workPlaceSlice";
import contactsSlice from "../features/inquiries/contactsSlice";
import portfolioitemSlice from "../features/portfolioitem/portfolioItemSlice";
import openingSlice from "../features/openings/openingsSlice";
import gallarySlice from "../features/gallary/gallarySlice";
import teammemberSlice from "../features/teammember/teamMemberSlice";
import CaseStudiesSlice from "../features/casestudies/casestudiesSlice";

const store = configureStore({
  reducer: {
    login: loginReducer,
    dashboard: dashboardSlice,
    dialog: dialogSlice,
    muidrawer: muiDrawerSlice,
    user: userSlice,
    menu: menuSlice,
    rights: rightsSlice,
    userType: userTypeSlice,
    cms: cmsSlice,
    pagination: paginationSlice,
    seotag: seotagSlice,
    blog: blogSlice,
    testimonial: testimonialSlice,
    banner: bannerSlice,
    faq: faqSlice,
    usefullinks: usefullinksSlice,
    setting: settingSlice,
    workflow: workflowSlice,
    clientLogo: clientLogoSlice,
    about: aboutSlice,
    coreservices: coreServiceSlice,
    services: serviceSlice,
    weprovide: weProvideSlice,
    whychoose: whyChooseSlice,
    branches: branchesSlice,
    technology: technologySlice,
    workculture: workCultureSlice,
    bestplace: bestplaceSlice,
    workplace: workplaceSlice,
    contacts: contactsSlice,
    portfolioitems: portfolioitemSlice,
    opening: openingSlice,
    gallary: gallarySlice,
    teammember: teammemberSlice,
    caseStudies: CaseStudiesSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
